import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import { Classes } from '@blueprintjs/core';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import cx from 'classnames';
import React__default, { forwardRef, Children, useState, useMemo } from 'react';
import { useDebounce } from 'react-use';
import { usePopperJsPositioning } from '../popover/utils.js';
import { SearchInput } from '../search-input/search-input.js';
import { Divider } from './dropdown-menu-divider.js';
import { Heading } from './dropdown-menu-heading.js';
import { StyledDropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuCheckboxItem } from './dropdown-menu-input-item.js';
import { DropdownMenuItem, DropdownMenuCustomItem } from './dropdown-menu-item.js';
import { SubMenu } from './dropdown-sub-menu.js';
import { menuHeights, menuWidths } from './utils/dropdown-menu-constants.js';
import { createDropdownMenuItems } from './utils/dropdown-menu-create-items.js';
import { searchDropdownMenuItems } from './utils/dropdown-menu-search-items.js';

var _excluded = ["content", "target", "className", "defaultOpen", "onOpenChange", "open", "placement", "tooltip", "contentWrapperProps", "maxHeight", "maxWidth", "modal"],
    _excluded2 = ["items", "searchPlaceholderText", "serverSideSearch", "serverSideDebounceTime", "onSearch", "t", "onOpenChange"];

var StyledListComponent = /*#__PURE__*/_styled("ul", {
  target: "ek9pqs20"
})({
  name: "1rye7jo",
  styles: "overflow:hidden auto;"
});

var StyledSearchListItem = /*#__PURE__*/_styled("li", {
  target: "ek9pqs21"
})({
  name: "z3y5x7",
  styles: "padding:0.5rem 0.75rem;"
});

var Menu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var content = _ref.content,
      target = _ref.target,
      className = _ref.className,
      defaultOpen = _ref.defaultOpen,
      onOpenChange = _ref.onOpenChange,
      open = _ref.open,
      placement = _ref.placement;
      _ref.tooltip;
      var contentWrapperProps = _ref.contentWrapperProps,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? "max" : _ref$maxHeight,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "medium" : _ref$maxWidth,
      _ref$modal = _ref.modal,
      modal = _ref$modal === void 0 ? true : _ref$modal,
      otherTriggerProps = _objectWithoutProperties(_ref, _excluded);

  var popperContentStyle = {
    maxHeight: menuHeights[maxHeight],
    maxWidth: menuWidths[maxWidth]
  };
  var popperContent = /*#__PURE__*/React__default.createElement(StyledListComponent, {
    className: cx(Classes.MENU),
    style: popperContentStyle
  }, content);

  var _usePopperJsPositioni = usePopperJsPositioning({
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    open: open,
    placement: placement,
    className: cx(className, "vds-dropdown-menu", "vds-popover"),
    arrowType: "none",
    content: popperContent,
    contentWrapperProps: contentWrapperProps,
    triggerRef: ref
  }),
      rootProps = _usePopperJsPositioni.rootProps,
      triggerProps = _usePopperJsPositioni.triggerProps,
      contentProps = _usePopperJsPositioni.contentProps;

  Children.only(target);
  return /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Root, _extends({}, rootProps, {
    modal: modal
  }), /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Trigger, _extends({}, otherTriggerProps, triggerProps), target), /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Content, _extends({
    loop: true
  }, contentProps)));
});
var MenuWithSearchTranslationKeys;

(function (MenuWithSearchTranslationKeys) {
  MenuWithSearchTranslationKeys["searchPlaceholderText"] = "varicent-design-system.dropdown-menu-with-search.search-placeholder";
})(MenuWithSearchTranslationKeys || (MenuWithSearchTranslationKeys = {}));

var defaultMenuWithSearchTranslation = _defineProperty({}, MenuWithSearchTranslationKeys.searchPlaceholderText, function () {
  return "Search";
});

var defaultMenuWithSearchTranslate = function defaultMenuWithSearchTranslate(arg) {
  return defaultMenuWithSearchTranslation[arg.id](arg.values);
};

var MenuWithSearch = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var items = _ref2.items,
      searchPlaceholderText = _ref2.searchPlaceholderText,
      serverSideSearch = _ref2.serverSideSearch,
      serverSideDebounceTime = _ref2.serverSideDebounceTime,
      onSearch = _ref2.onSearch,
      _ref2$t = _ref2.t,
      t = _ref2$t === void 0 ? defaultMenuWithSearchTranslate : _ref2$t,
      onOpenChange = _ref2.onOpenChange,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = useState(items),
      _useState4 = _slicedToArray(_useState3, 2),
      itemsToRender = _useState4[0],
      setItemsToRender = _useState4[1];

  useDebounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var searchToLowerCase, newItemsToRender;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (searchValue) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", setItemsToRender(items));

          case 2:
            searchToLowerCase = searchValue.toLowerCase();

            if (!onSearch) {
              _context.next = 8;
              break;
            }

            _context.next = 6;
            return onSearch(searchToLowerCase, items);

          case 6:
            newItemsToRender = _context.sent;
            return _context.abrupt("return", setItemsToRender(newItemsToRender));

          case 8:
            return _context.abrupt("return", setItemsToRender(searchDropdownMenuItems(items, searchToLowerCase)));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), serverSideSearch ? serverSideDebounceTime : 0, [searchValue, items]);

  var onSearchChange = function onSearchChange(e) {
    setSearchValue(e.target.value);
  };

  var onSearchClear = function onSearchClear() {
    setSearchValue("");
  };

  var onSearchKeyDown = function onSearchKeyDown(e) {
    // Prevent the dropdown from firing keyboard events
    e.stopPropagation();
  };

  var onOpenChangeInner = function onOpenChangeInner(open) {
    if (!open) onSearchClear();
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
  };

  var contentItems = useMemo(function () {
    return createDropdownMenuItems(itemsToRender);
  }, [itemsToRender]);
  var content = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledSearchListItem, {
    key: "search"
  }, /*#__PURE__*/React__default.createElement(SearchInput, {
    value: searchValue,
    placeholder: searchPlaceholderText !== null && searchPlaceholderText !== void 0 ? searchPlaceholderText : t({
      id: MenuWithSearchTranslationKeys.searchPlaceholderText
    }),
    onChange: onSearchChange,
    onClearValue: onSearchClear,
    onKeyDown: onSearchKeyDown
  })), contentItems);
  return /*#__PURE__*/React__default.createElement(Menu, _extends({}, rest, {
    ref: ref,
    content: content,
    onOpenChange: onOpenChangeInner
  }));
});
var DropdownMenu = {
  Menu: Menu,
  MenuWithSearch: MenuWithSearch,
  Item: DropdownMenuItem,
  CustomItem: DropdownMenuCustomItem,
  RadioGroup: StyledDropdownMenuRadioGroup,
  RadioItem: DropdownMenuRadioItem,
  CheckboxItem: DropdownMenuCheckboxItem,
  Divider: Divider,
  // Divider aliases
  Separator: Divider,
  Seperator: Divider,
  SubMenu: SubMenu,
  Heading: Heading,
  // Heading aliases
  Label: Heading
};

export { DropdownMenu };
//# sourceMappingURL=dropdown-menu.js.map
